import kr from "../../kr/kr";
import Swiper, { Navigation, EffectFade, Autoplay } from "swiper";
Swiper.use([Navigation, EffectFade, Autoplay]);

export default class Slider extends kr.Component {
  init() {
    this._selector = ".section--slider .jsSlider";

    this.slider = new Swiper(this._selector, {
      loop: true,
      effect: "fade",
      autoplay: {
        delay: 8000,
      },
      navigation: {
        nextEl: ".slider__nav--next",
        prevEl: ".slider__nav--prev",
      },
    });
  }
}

kr.registerComponent(".section--slider", {
  component: Slider,
});
